export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {}

  try {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    textArea.style.top = '-9999px';
    textArea.style.opacity = '0';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    const result = document.execCommand('copy');
    document.body.removeChild(textArea);
    return result;
  } catch {
    return false;
  }
};

export const readFromClipboard = async (): Promise<{ text: string; error?: string }> => {
  try {
    if (navigator.clipboard) {
      const text = await navigator.clipboard.readText();
      return { text: text || '' };
    }
  } catch (e: any) {
    if (e?.name === 'NotAllowedError') {
      return { text: '', error: 'clipboard_denied' };
    }
  }

  return { text: '', error: 'clipboard_unavailable' };
};
